import { ProjectCheckpoints } from '../../../../domain/projectCheckpoints/projectCheckpoints';
import EmployeeSelector from '../../../employees/components/EmployeeSelector';
import TextAreaField from '../../../shared/components/forms/TextAreaField';
import TextField from '../../../shared/components/forms/TextField';

interface Props {
    projectCheckpoint: ProjectCheckpoints;
    onChange: (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => void;
}

export default function ProjectCheckpointDetailsSection({
    projectCheckpoint,
    onChange: handleInputChange,
}: Props) {
    return (
        <>
            <h5 className='mb-3'>Nuevo Seguimiento</h5>
            <div className='col-7'>
                <EmployeeSelector
                    onChange={handleInputChange}
                    key='employeeId'
                    name='employeeId'
                    value={projectCheckpoint.employeeId}
                />
            </div>
            <div className='col-12'>
                <TextAreaField
                    name='comments'
                    value={projectCheckpoint.comments}
                    label='Comentarios'
                    required={false}
                    onChange={handleInputChange}
                    key='comments'
                />
            </div>
        </>
    );
}
